import React, { useState } from 'react';
// import React, { useRef, useState } from 'react';
// import PropTypes from 'prop-types';
// import styles from './E3WijmoGrid.module.css';

import '@grapecity/wijmo.styles/wijmo.css';
import '@grapecity/wijmo.cultures/wijmo.culture.ko';

import styles from './E3WijmoGrid.module.css';

// import { CollectionView, asEnum } from '@grapecity/wijmo';
// import { CellType, DataMap, SelectionMode, CellRange } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
// import { CellMaker } from '@grapecity/wijmo.grid.cellmaker';
// import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
// import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
// import * as wjcXlsx from '@grapecity/wijmo.xlsx';

/**
 * E3WijmoGrid
 * @type React.FC<E3WijmoGridPropTypes>
 */
const E3WijmoGrid = React.forwardRef((props, ref) => {
  console.log(props);
  React.useImperativeHandle(ref, () => ({
    test() {
      console.log('test');
    },
  }));

  /**
   * E3WijmoGrid Component의 State
   */
  const [currState, setCurrState] = useState({
    allowAddNew: props.allowAddNew,
    allowDelete: props.allowDelete,
  });

  return (
    <div className={styles.container}>
      <FlexGrid itemsSource={this.state.data}>
        <FlexGridColumn header="ID" binding="id" allowDragging={false} />
        <FlexGridColumn header="Country" binding="country" />
        <FlexGridColumn header="Downloads" binding="downloads" />
        <FlexGridColumn header="Sales" binding="sales" />
        <FlexGridColumn header="Expenses" binding="expenses" />
      </FlexGrid>
    </div>
  );
});

const E3WijmoGridPropTypes = {
  // style: PropTypes.object,
  // theme: PropTypes.string,
  // width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // columns: PropTypes.array.isRequired,
  // columnGroups: PropTypes.array,
  // allowAddNew: PropTypes.bool,
  // allowDelete: PropTypes.bool,
  // selectionMode: PropTypes.string,
  // onRowClick: PropTypes.func,
  // onRowDoubleClick: PropTypes.func,
  // sortDescriptions: PropTypes.array,
  // groupDescriptions: PropTypes.array,
  // trackChanges: PropTypes.bool,
  // filter: PropTypes.bool,
  // quickAutoSize: PropTypes.bool,
  // allowPinning: PropTypes.string,
  // isNo: PropTypes.bool,
  // codeId: PropTypes.string,
  // frozenRow: PropTypes.number,
  // frozenColumn: PropTypes.number,
  // allowMerging: PropTypes.string,
  // isReadOnly: PropTypes.bool,
  // exportExcel: PropTypes.bool,
  // defaultColumn: PropTypes.bool,
  // onCellUpdate: PropTypes.func,
  // onCellEditEnding: PropTypes.func,
  // beginningEdit: PropTypes.func,
  // sortedColumn: PropTypes.func,
  // isAllCheckbox: PropTypes.bool,
  // checkBoxColumn: PropTypes.string,
};

E3WijmoGrid.propTypes = E3WijmoGridPropTypes;
E3WijmoGrid.defaultProps = {
  // width: '100%',
  // height: '100%',
  // columns: [],
  // columnGroups: [],
  // allowAddNew: true,
  // allowDelete: true,
  // selectionMode: 'Row',
  // onRowClick: null,
  // onRowDoubleClick: null,
  // sortDescriptions: [],
  // groupDescriptions: [],
  // trackChanges: true,
  // filter: false,
  // quickAutoSize: true,
  // allowPinning: '',
  // isNo: true,
  // frozenRow: 0,
  // frozenColumn: 0,
  // allowMerging: 'Cells',
  // isReadOnly: true,
  // exportExcel: false,
  // defaultColumn: false,
  // onCellUpdate: null,
  // onCellEditEnding: null,
  // beginningEdit: null,
  // sortedColumn: null,
  // isAllCheckbox: false,
  // checkBoxColumn: 'CHK',
};
E3WijmoGrid.displayName = 'E3WijmoGrid';
export default E3WijmoGrid;
